<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img
          src="/logo.png"
          class="login-brand-logo"
          :alt="$branding.logo.alt"
        >
        <!-- <h2 class="brand-text text-primary ml-1 mt-2">
          Faster Go
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center "
      >
        <b-img
          fluid
          :src="imgUrl"
          alt="Login V2"
        />

      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <div class="d-flex justify-content-center mb-1">
            <b-spinner
              v-if="isLoading === true"
              class="mr-1"
              variant="primary"
            />
          </div>
          <b-card-title
            class="mb-1 font-weight-bold text-center"
            title-tag="h2"
          >
            Bienvenue à Yass Express 👋
          </b-card-title>
          <b-card-text class="mb-2 text-center text-muted">
            Connectez-vous à votre compte pour gérer vos livraisons
          </b-card-text>
          <p v-if="incorrectAuth">
            Incorrect username or password entered - please try again
          </p>
          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- username -->
              <b-form-group
                label="Email"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="Username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="admin"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Mot de passe</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
              >
                Connexion
              </b-button>

              <b-card-text class="mt-2 mb-2 h4" />
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip, BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/store'
import index from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      isLoading: false,
      status: '',
      password: '',
      email: '',
      incorrectAuth: false,
      // eslint-disable-next-line global-require
      sideImg: require('@/assets/images/login.webp'),
      // validation rules
      required,
    }
  },
  computed: {
    companyName() {
      // Use branding from plugin
      return this.$branding?.company?.shortName || this.$branding?.company?.name || ''
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (index.state.appConfig.layout.skin === 'dark') {
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
    async login() {
      this.isLoading = true
      try {
        const { email, password } = this
        await store.dispatch('userLogin', { email, password })
        this.isLoading = false
        const { role: userRole } = store.state
        if (userRole === 'sales') {
          this.$router.push({ name: 'supplier-add' })
        } else if (userRole === 'customer_support') {
          this.$router.push({ name: 'SupportTicketList' })
        } else if (userRole === 'admin_developer') {
          this.$router.push({ name: 'invoice-list-direx' })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      } catch (error) {
        this.isLoading = false
        setTimeout(() => {
          this.showToast('danger', 'top-center', 'email ou mot de passe invalide')
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v2 .brand-logo .login-brand-logo {
  display: block;
  width: 360px;
  max-width: 42vw;
  height: auto;
  object-fit: contain;
}

@media (max-width: 991.98px) {
  .auth-wrapper.auth-v2 .brand-logo .login-brand-logo {
    width: 240px;
    max-width: 58vw;
  }
}
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
